﻿/*------------------------------------*\
    #GRAIN-PRICE
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.grainPrice = (function () {
    var priv = {};
    var priceHistorySelector = '#price-grain-history';
    var priceHistoryRange = {
        min: new Date(2026, 0, 1),
    };

    var formatDateForAttribute = function (date) {
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var day = date.getDate().toString().padStart(2, '0');
        return date.getFullYear() + '-' + month + '-' + day;
    };

    var applyBoundsToPicker = function ($picker, range) {
        if (!$picker.length) {
            return;
        }

        if (range.min) {
            $picker.attr('min', formatDateForAttribute(range.min));
            $picker.data('minDate', range.min);
            if ($.fn.datepicker && $picker.hasClass('hasDatepicker')) {
                $picker.datepicker('option', 'minDate', range.min);
            }
        }
    };

    /**
     * Private initialization method
     */
    priv.init = function () {
        applyBoundsToPicker($(priceHistorySelector), priceHistoryRange);
    };


    // Initialize module
    $(function () {
        priv.init();
    });
})();
